import { render, staticRenderFns } from "./new-order-link.vue?vue&type=template&id=f838c090&"
import script from "./new-order-link.vue?vue&type=script&lang=js&"
export * from "./new-order-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports